/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportAddressDTO } from './etransport-address-dto.model';

export class ETransportLocationDTO extends JSONable {

  uuid: string | null = null;
  ptfUuid: string | null = null;
  customsOfficeUuid: string | null = null;
  addressDTO: ETransportAddressDTO | null = null;

}
